/* NK — page produit : ordre des sections.

   Ordre visé, à la suite du bloc principal :
     1. les rubriques (description, livraison, etc.)
     2. « Nos produits en vidéo »
     3. le bandeau défilant des marques
     4. « La voix de nos clients », qui remplace l'ancienne section
        « Vos Retours » (celle-ci est masquée).

   Les identifiants de section Shopify sont préfixés par le template
   (shopify-section-template--123__xxx) : on cible donc par suffixe.
   10/10 : plus de défilement automatique des photos clients. */
(function(){
  function bySuffix(suffix){
    return document.querySelector('[id$="__' + suffix + '"]') || document.getElementById('shopify-section-' + suffix);
  }

  function findRetours(){
    var s = bySuffix('custom_liquid_yyEezb');
    if (s) return s;
    var c = document.querySelector('.custom-carousel');
    return c ? (c.closest('.shopify-section') || c.parentElement) : null;
  }

  function findTabs(){
    var s = bySuffix('product-details-tabs');
    if (s) return s;
    var t = document.querySelector('.product-details-tabs, [class*="product-tabs"]');
    return t ? (t.closest('.shopify-section') || null) : null;
  }

  function boot(){
    var retours = findRetours();
    if (!retours) return;
    var parent = retours.parentNode;

    /* 1. Les rubriques remontent au-dessus. */
    var tabs = findTabs();
    if (tabs && tabs !== retours &&
        (tabs.compareDocumentPosition(retours) & Node.DOCUMENT_POSITION_PRECEDING)) {
      parent.insertBefore(tabs, retours);
    }

    /* 2 et 3. Vidéos puis marques, juste avant l'emplacement des avis. */
    var vid = document.getElementById('nk-video-host');
    if (vid) {
      parent.insertBefore(vid, retours);
      vid.hidden = false;
      initVideos(vid);
    }

    var brands = document.getElementById('nk-brands-host');
    if (brands) {
      parent.insertBefore(brands, retours);
      brands.hidden = false;
    }

    /* 4. Les avis clients remplacent « Vos Retours » (sans défilement automatique). */
    var voice = document.getElementById('nk-voice-host');
    if (voice) {
      parent.insertBefore(voice, retours);
      voice.hidden = false;
      retours.style.display = 'none';
      retours.setAttribute('aria-hidden', 'true');
    }
  }

  /* Défilement automatique générique pour un rail horizontal. */
  function autoScroll(root, track, stepFn, delay, isBlocked){
    var paused = false, inView = true;
    setInterval(function(){
      if (paused || !inView) return;
      if (isBlocked && isBlocked()) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var end = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      track.scrollTo({ left: end ? 0 : track.scrollLeft + stepFn(), behavior:'smooth' });
    }, delay);
    root.addEventListener('mouseenter', function(){ paused = true; });
    root.addEventListener('mouseleave', function(){ paused = false; });
    ['pointerdown','touchstart','wheel'].forEach(function(ev){
      track.addEventListener(ev, function(){
        paused = true;
        clearTimeout(track.__nkResume);
        track.__nkResume = setTimeout(function(){ paused = false; }, 4000);
      }, { passive:true });
    });
    if ('IntersectionObserver' in window){
      new IntersectionObserver(function(en){
        en.forEach(function(e){ inView = e.isIntersecting; });
      }, { threshold:.1 }).observe(root);
    }
  }

  function initVideos(root){
    if (root.dataset.nkInit) return;
    root.dataset.nkInit = '1';
    var track = root.querySelector('[data-nk-vid-track]');
    var cards = [].slice.call(root.querySelectorAll('.nk-vid__card'));
    if (!track || !cards.length) return;
    var playing = false;

    function stopAll(except){
      cards.forEach(function(c){
        var v = c.querySelector('[data-nk-v]');
        if (!v || v === except) return;
        v.pause(); v.currentTime = 0; v.muted = true;
        c.classList.remove('is-playing');
      });
    }

    cards.forEach(function(c){
      var v = c.querySelector('[data-nk-v]');
      var b = c.querySelector('[data-nk-play]');
      if (!v) return;
      function toggle(e){
        if (e) e.preventDefault();
        if (!v.paused) { v.pause(); c.classList.remove('is-playing'); playing = false; return; }
        stopAll(v);
        v.muted = false;
        var p = v.play();
        if (p && p.catch) p.catch(function(){ v.muted = true; v.play(); });
        c.classList.add('is-playing');
        playing = true;
      }
      if (b) b.addEventListener('click', toggle);
      v.addEventListener('click', toggle);
      v.addEventListener('pause', function(){ c.classList.remove('is-playing'); });
      v.addEventListener('ended', function(){ c.classList.remove('is-playing'); playing = false; });
    });

    if ('IntersectionObserver' in window){
      new IntersectionObserver(function(en){
        en.forEach(function(e){ if (!e.isIntersecting){ stopAll(null); playing = false; } });
      }, { threshold:.15 }).observe(root);
    }
    document.addEventListener('visibilitychange', function(){
      if (document.hidden){ stopAll(null); playing = false; }
    });

    autoScroll(root, track, function(){
      return cards[0].getBoundingClientRect().width + 12;
    }, 4000, function(){ return playing; });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
